import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';
import {
  Item,
  Title,
  Subtitle,
  Price,
  IconWrapper,
  Counter,
  Summary,
  Publications,
  Description,
  IconTrash,
  TabItem,
  Subtotal,
  Day,
  Content,
  SubtotalPrice,
  Available
} from './styled';
import {
  PublicationModel,
  deletePrintAllByChannel,
  clearExtracharge,
  clearPhotoVignette,
} from '@app/src/views/StepTwo/channelPublication';
import { deleteAllDateSelected } from '@app/src/common/datePicker/state/calendar/actions';
import { isClientEnv } from '@app/src/utils/validations';
import { configCalendarId } from '@app/src/views/StepTwo/channelPublication/components/ChannelsPublication/constants';
import { selectExtracharge } from '../../state/extracharge/actions';
import { setPriceTotalByChannel } from '@app/src/views/StepOne/form';

interface Props {
  title?: string;
  day?: string;
  priceIgv?: number;
  details?: PublicationModel[];
  idNewspaper?: number;
  handleClickItem?: Function;
  priceSubTotal?: string;
  extrachargeSelected?: any;
  available?: number;
}

const isClient = isClientEnv();

export const OptionChannelSummary: React.FC<Props> = ({
  title,
  day,
  priceIgv,
  details,
  idNewspaper,
  handleClickItem,
  priceSubTotal,
  available
}) => {
  const dispatch = useDispatch();
  const publicationLabel = details && details.length == 1 ? 'Publicación' : 'Publicaciones';
  const printsByChannel = useSelector(state => state.print.printsByChannel);
  const print = useSelector(state => state.print);
  const [countByChannel, setCountByChannel] = useState(0);
  const typeUserAction = useSelector(state => state.session.user.payment);
  const extracharges = useSelector(state => state.extracharge.data);
  const availableCounter = useSelector(state => state.myPackageAvailable.counter);
  const availableByNewspaper = availableCounter && availableCounter[idNewspaper];
  const counterBoth = availableCounter && availableCounter.both;

  useEffect(() => {
    if (available) {
      const countByChannel = getPrintsByChannelUnique(idNewspaper) || 0;
      setCountByChannel(countByChannel);
    }

  }, [printsByChannel, available]);

  const getPrintsByChannelUnique = (channelId) => {
    const currentData = printsByChannel && Object.keys(printsByChannel);
    const byChannel = { 1: [], 2: [], 3: [] };
    if (currentData && currentData.length > 0) {
      currentData.map(item => {
        printsByChannel[item].map(el => {
          if (el) {
            byChannel && byChannel[el && el.newspaperId] && byChannel[el && el.newspaperId].push(el);
          }
        })
      })
      return byChannel[channelId] && byChannel[channelId].length;
    }
  };

  const handleClickOpen = () => {
    handleClickItem && handleClickItem();
  };

  const handleClickDelete = useCallback(() => {
    const isDiscard = confirm('Todos los cambios se borrarán, ¿desea seguir con la acción?');
    if (isDiscard) {
      const packages = Object.values(configCalendarId);
      if (typeUserAction === 'purchase-print') {
        packages.map(channel => {
          if (channel.groupId === idNewspaper) {
            dispatch(deletePrintAllByChannel(channel.id));
            dispatch(clearPhotoVignette(channel.id));
            dispatch(deleteAllDateSelected(channel.id));
            dispatch(clearExtracharge(channel.id));
            dispatch(setPriceTotalByChannel(channel.id, { price: 0, priceIgv: 0 }));
          }
        })
      } else {
        packages.map(channel => {
          if (channel.groupId === idNewspaper) {
            dispatch(deletePrintAllByChannel(channel.id));
            dispatch(clearPhotoVignette(channel.id));
            dispatch(deleteAllDateSelected(channel.id));
          }
        })
        setClearExtracharges();
      }
      isClient && sessionStorage.setItem('print', JSON.stringify(print));
    }
  }, [printsByChannel, availableByNewspaper]);

  const setClearExtracharges = () => {
    const findInit = { 1: [1, 3], 2: [2, 4, 5] };
    const printsNewspaper = findInit[idNewspaper];
    for (let j = 0; j < printsNewspaper.length; j++) {
      const channelId = printsNewspaper[j];
      const printsChannel = printsByChannel[channelId];
      const extrachargeChannel = extracharges[channelId].data;
      const extraSelecteds = extrachargeChannel.filter(item => (item.checked === true));
      if (printsChannel && printsChannel.length === 0 && extraSelecteds.length > 0) {
        extraSelecteds.map((selected) => {
          let printsAllWithExtra = getPrintsRestNewspaperByExtracharge(selected.extrachargeId, idNewspaper, channelId);
          let currentAvailableExtra = availableByNewspaper && availableByNewspaper.extra && availableByNewspaper.extra[selected.extrachargeId];
          const group = { 1: [1, 3], 2: [2, 4, 5] };
          const currentGroup = group[idNewspaper];
          const groupBoth = { 1: 2, 2: 1 };
          const isInBoth = counterBoth && counterBoth.hasOwnProperty(selected.extrachargeId);
          if (isInBoth) {
            printsAllWithExtra = getPrintsRestAllBothNewspaperByExtracharge(selected.extrachargeId, channelId);
            currentAvailableExtra = counterBoth[selected.extrachargeId];
          }
          console.log(printsAllWithExtra, 'prinstAllWithExtra')
          console.log(currentAvailableExtra, 'currenAvailabelEXtra', selected)
          currentGroup.map((channel) => {
            const currentExtras = extracharges[channel].data;
            if (channel === channelId && printsByChannel[channelId].length === 0) {
              dispatch(selectExtracharge(channel, selected.extrachargeId, false, currentAvailableExtra - printsAllWithExtra));
            } else {
              const beforeItem = currentExtras.filter(x => x.extrachargeId === selected.extrachargeId)[0];

              dispatch(selectExtracharge(channel, selected.extrachargeId, beforeItem.checked, currentAvailableExtra - printsAllWithExtra));
            }
          });
          if (counterBoth && counterBoth[selected.extrachargeId]) {
            const lastNewspaper = groupBoth[idNewspaper];
            const alternGroup = group[lastNewspaper];

            alternGroup.map(channel => {
              const currentExtras = extracharges[channel].data;
              const beforeItem = currentExtras.filter(x => x.extrachargeId === selected.extrachargeId)[0];
              dispatch(selectExtracharge(channel, selected.extrachargeId, beforeItem.checked, currentAvailableExtra - printsAllWithExtra));
            });
          }
        })
        console.log('aplica borrado')
      }
    }
  };

  const getPrintsRestNewspaperByExtracharge = (extrachargeId, newspaperId, channelId) => {
    const group = { 1: [1, 3], 2: [2, 4, 5] };
    const currentGroup = group[newspaperId];
    let count = 0;

    currentGroup.map(channel => {
      const extraSelecteds = extracharges[channel].data.filter(item => item.checked === true);
      extraSelecteds.map(selected => {
        if (selected.extrachargeId === extrachargeId) {
          if (channel !== channelId) {
            count = count + (printsByChannel[channel] && printsByChannel[channel].length || 0)
          }
        }
      })
    });
    return count;
  };

  const getPrintsRestAllBothNewspaperByExtracharge = (extrachargeId, channelId) => {
    const groupBoth = { 1: 2, 2: 1 };
    const complementNewspaperId = groupBoth[idNewspaper];
    const printsRestNewspaperWithExtra = getPrintsRestNewspaperByExtracharge(extrachargeId, idNewspaper, channelId);
    const printsComplementNewspaperWithExtra = getPrintsRestNewspaperByExtracharge(extrachargeId, complementNewspaperId, channelId);
    return printsRestNewspaperWithExtra + printsComplementNewspaperWithExtra;
  };


  return (
    <Item>
      <TabItem onClick={handleClickOpen}>
        <Title>{`Clasificados ${title}`}{day && <Day> - {day}</Day>} {
          available && <Available>{available - countByChannel} Disponible(s) </Available>
        }</Title>
        {priceIgv ? <Subtitle>Precio por publicación desde <Price>{`S/ ${priceIgv}`}</Price></Subtitle> : null}
        <IconWrapper>
          {details && details.length > 0 && <Counter color={COLORS.BLUE_LINK}>{details.length}</Counter>}
          <Icon data-name="icon-expand-more" fill={COLORS.BLUE_LINK} width="9" height="9" />
        </IconWrapper>
      </TabItem>
      {
        details && details.length > 0 &&
        <Summary>
          <Publications>{details.length} {publicationLabel}</Publications>
          <Content>
            {details && details.map((item, index) => (
              <Description key={index}>{item.dateFormat}</Description>
            ))}
          </Content>
          {/* {
            extrachargeSelected && extrachargeSelected.length > 0 &&
            <React.Fragment>
              <Publications>Extracargos</Publications>
              <Content>
                {
                  extrachargeSelected.map((item, index) => (
                    <Description key={index}>{item.name} x {details.length}</Description>
                  ))
                }
              </Content>
            </React.Fragment>
          } */}
          {priceSubTotal && <Subtotal>Sub Total<SubtotalPrice>S/ {priceSubTotal}</SubtotalPrice></Subtotal>}
          <IconTrash onClick={handleClickDelete}>
            <Icon data-name="icon-trash" fill={COLORS.BLACK_BOLD} width="16" height="16" />
          </IconTrash>
        </Summary>
      }
    </Item>
  )
};
